module.exports = __webpack_public_path__ + "static/media/us.da5263c8.webp";